/**
 * @file By attaching v-t to an attribute, this directive will set attribute with translated value, leaving the text content in place
 * If attribute (arg) is not passed into directive, it will replace the text content with attribute value (binding.value)
 * If neither arguments are passed in, it will set text content with translated text
 */
import { __ } from 'bits/intl'

const t = {
  bind: (el, binding): void => {
    if (binding.arg) {
      const phrase = binding.value
      const translatedPhrase = __(String(phrase).trim())
      el.setAttribute(binding.arg, translatedPhrase)
    } else {
      const phrase = binding.value || el.textContent
      const translatedPhrase = __(String(phrase).trim())
      el.textContent = translatedPhrase
    }
  },
}

export default t
